// extracted by mini-css-extract-plugin
export var cardTitle = "_ji-1";
export var commentBubble = "_ji-e";
export var commentForm = "_ji-a";
export var commentInput = "_ji-b";
export var commentLabel = "_ji-d";
export var commentPrompt = "_ji-9";
export var csatCard = "_ji-0";
export var feedbackSection = "_ji-7";
export var starDisabled = "_ji-6";
export var starEmpty = "_ji-5";
export var starFilled = "_ji-4";
export var starWrapper = "_ji-3";
export var starsContainer = "_ji-2";
export var submittedComment = "_ji-c";
export var thankYouText = "_ji-8";